/* eslint-disable react/require-default-props */

/* eslint-disable max-params */

import type React from 'react';

import { useState } from 'react';

import { motion } from 'framer-motion';

import { ComingSoonBadge } from '@/components/ui/comingSoonBadge';

import HCarousel3D from './Hcarousel-3d';

const AlternativeCard = ({
  totalItems,
  currentIndex,
  onIndicatorClick,
  children,
  style,
  comingSoon = false,
}: {
  totalItems: number
  currentIndex: number
  onIndicatorClick: (index: number) => void
  children: React.ReactNode
  style?: React.CSSProperties
  comingSoon?: boolean
}) => {
  return (
    <motion.div
      className="relative overflow-hidden rounded-2xl p-2 text-black w-full h-full"
      style={{ ...style, minHeight: '320px', minWidth: '310px' }}
    >
      {/* Indicadores en la esquina superior */}
      <div className="absolute right-5 top-4 flex gap-1.5 md:hidden">
        {Array.from({ length: Math.min(totalItems || 3, 5) }, (_, index) => {
          return (
            <motion.div
              key={index}
              className={`h-2 w-2 rounded-full cursor-pointer transition-all duration-300 ${
                currentIndex === index ? 'bg-gradient-50 shadow-lg shadow-primary-300 ring-2 ring-white/30' : 'bg-gradient-50 hover:bg-gradient-50 opacity-60 hover:opacity-100'
              }`}
              onTap={() => { return onIndicatorClick?.(index); }}
              whileHover={{
                scale: 1.2,
                transition: { type: 'spring', stiffness: 400, damping: 15 },
              }}
              whileTap={{ scale: 0.9 }}
              animate={{
                scale: currentIndex === index ? 1.1 : 1,
                boxShadow:
              currentIndex === index ? '0 0 15px rgba(255, 255, 255, 0.6), 0 0 30px rgba(255, 255, 255, 0.3)' : 'none',
              }}
            />
          );
        })}
      </div>

      {comingSoon && (
        <ComingSoonBadge className="absolute top-0 right-0 z-[60]" />
      )}

      <div className={comingSoon ? 'grayscale pointer-events-none' : ''}>
        {children}
      </div>
    </motion.div>
  );
};

// eslint-disable-next-line react/require-default-props
export const AlternativeCarousel = ({ autoPlay = false }: { autoPlay?: boolean }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleIndicatorClick = (index: number) => {
    setCurrentIndex(index);
  };

  const alternativeCards = [
    <AlternativeCard
      key="trending"
      style={{ background: 'linear-gradient(to bottom right, rgb(249, 115, 22), rgb(220, 38, 38), rgb(190, 24, 93))' }}
      totalItems={4}
      currentIndex={currentIndex}
      onIndicatorClick={handleIndicatorClick}
    >
      <div>
        <h3>Tendencias</h3>
        <p>Descubre nuevas oportunidades y maximiza tus beneficios con nuestras herramientas avanzadas.</p>
      </div>
    </AlternativeCard>,
    <AlternativeCard
      key="community"
      style={{ background: 'linear-gradient(to bottom right, rgb(34, 197, 94), rgb(13, 148, 136), rgb(59, 130, 246))' }}
      totalItems={4}
      currentIndex={currentIndex}
      onIndicatorClick={handleIndicatorClick}
    >
      <div>
        <h3>Tendencias</h3>
        <p>Descubre nuevas oportunidades y maximiza tus beneficios con nuestras herramientas avanzadas.</p>
      </div>
    </AlternativeCard>,
    <AlternativeCard
      key="rewards"
      style={{ background: 'linear-gradient(to bottom right, rgb(168, 85, 247), rgb(99, 102, 241), rgb(59, 130, 246))' }}
      totalItems={4}
      currentIndex={currentIndex}
      onIndicatorClick={handleIndicatorClick}
    >
      <div>
        <h3>Tendencias</h3>
        <p>Descubre nuevas oportunidades y maximiza tus beneficios con nuestras herramientas avanzadas.</p>
      </div>
    </AlternativeCard>,
    <AlternativeCard
      key="goals"
      style={{ background: 'linear-gradient(to bottom right, rgb(234, 179, 8), rgb(249, 115, 22), rgb(220, 38, 38))' }}
      totalItems={4}
      currentIndex={currentIndex}
      onIndicatorClick={handleIndicatorClick}
    >
      <div>
        <h3>Tendencias</h3>
        <p>Descubre nuevas oportunidades y maximiza tus beneficios con nuestras herramientas avanzadas.</p>
      </div>
    </AlternativeCard>,
  ];

  return (
    <HCarousel3D
      items={alternativeCards}
      baseWidth={316}
      gap={24}
      animated
      autoPlay={autoPlay}
      enable3D
      currentIndex={currentIndex}
      onIndexChange={setCurrentIndex}
      opts={{
        align: 'center',
        active: true,
        duration: 0.7,
      }}
    />
  );
};

export default AlternativeCard;
